// Build only local Operations URLs from known branch collection references.
export function orderLink(row) {
  const match = typeof row?.wwsOrderRef === "string" && /^(demoDeliverOrders|deliverOrders)_(ny|chi)\/([A-Za-z0-9_-]{1,200})$/.exec(row.wwsOrderRef);
  if (!match) return null;
  const demo = match[1] === "demoDeliverOrders";const branch = match[2].toUpperCase();const id = match[3];
  if (demo !== id.startsWith("DO_DEMO_") || (row.branch && row.branch !== branch)) return null;
  return {href: `/operation/${encodeURIComponent(id)}?branch=${branch}`, branch, demo, label: row.cid || id};
}
export function operationBranch(search) {
  const branch = new URLSearchParams(search).get("branch");
  return ["NY", "CHI"].includes(branch) ? branch : null;
}
